import React from 'react';
import * as Styles from './BlockOptions.styles';
import { Button, IconArrow } from 'gatorcomponents';

const BlockOptions = ({
  icon,
  title,
  description,
  subtitle,
  buttonLabel,
  buttonClick,
  buttonTestId = 'block-options-button',
}) => (
  <Styles.Block>
    <Styles.BlockHeader>
      <Styles.TitleWrapper>
        {title && <Styles.Title>{title}</Styles.Title>}
        {icon}
      </Styles.TitleWrapper>
      {subtitle && <Styles.Subtitle>{subtitle}</Styles.Subtitle>}
    </Styles.BlockHeader>
    {description && <Styles.Description>{description}</Styles.Description>}
    {buttonLabel && (
      <Styles.ButtonWrapper>
        <Button
          testId={buttonTestId}
          iconLeft={null}
          label={buttonLabel}
          title={buttonLabel}
          size="medium2"
          variant="text"
          iconRight={<IconArrow direction="right" size="sm" color="primaryMedium" />}
          width="fit-content"
          onClick={buttonClick}
        />
      </Styles.ButtonWrapper>
    )}
  </Styles.Block>
);

export default BlockOptions;
